import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getParkList } from '../../../../../api/MyStat/apiPark';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ReqParkList } from '../../../../../item/MyStat/ItemPark';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_string, get_activation_color } from '../../../../../item/MyStat/ItemMyStatBase';

export function ParkList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [searchItems, setSearchItems] = useState([])

    const [parkList, setParkList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    // const [mReqParkList, setReqParkList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [searchItem, set_searchItem] = useState()

    useEffect(() => {
        var searchItems = [
            [
                new SearchInput({
                    key: 'park_name',
                    val: '',
                    defaultVal: '',
                    title: '以中文名稱搜尋',
                    col: 4
                }),
                new SearchSelect({
                    key: 'park_activation',
                    val: ACTIVATION_ENABLE,
                    defaultVal: ACTIVATION_ENABLE,
                    valType: SELECT_VAL_TYPE_INT,
                    title: '狀態',
                    col: 4,
                    attr: search_activation_attr
                })
            ],
            // new SearchBrLine()
        ]
        setSearchItems(searchItems)
    }, [])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqParkList = new ReqParkList({ start, limit })
            if (url === "") {
                toSearch({ searchItem: mReqParkList, page: url.page })
            } else {
                mReqParkList.fromJson(url)
                // console.log(mReqParkList)
                toSearch({ searchItem: mReqParkList, page: url.page })
            }
        }
    }, [id])

    useEffect(() => {
        var contents = []
        parkList.forEach(item => {
            var content = []
            content.push(setTD({ content: item._id }))
            content.push(setTDLink({ link: 'Park_Detail', content: item.park_name + " " + moment(item.park_DOB).format('YYYY'), key: 'ParkEdit', val: item }))
            content.push(setTD({ content: item.park_name_eng }))
            content.push(setTD({ content: moment(item.logo_park_date).format('YYYY-MM-DD') }))
            content.push(setTD({ content: get_activation_string(item.park_activation), color: get_activation_color(item.park_activation) }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('編號', 2),
                new TableListTitle('中文名稱', 3),
                new TableListTitle('英文姓名', 3),
                new TableListTitle('異動日期', 2),
                new TableListTitle('狀態', 2),
            ],
            contents
        }

        set_list_obj(lb)

    }, [parkList])

    function toActionSearch(searchItems) {
        // console.log(searchItems)
        var mReqParkList = new ReqParkList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    mReqParkList[item.key] = item.val
                })
            }
        })
        console.log(mReqParkList)
        setSearchItems(searchItems)
        toSearch({ searchItem: mReqParkList})
    }

    function toSearch({ searchItem, page = 1 }) {
        console.log("toSearch")
        console.log(searchItem)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqParkList = new ReqParkList({ start, limit })
        if (searchItem !== undefined){
            mReqParkList.fromJson(searchItem)
            mReqParkList.start = start
            mReqParkList.limit = limit
        }
        // setReqLeagueList(mReqLeagueList)
        set_searchItem(mReqParkList)
        setVal2Token("url", mReqParkList, id)
        getParkList(mReqParkList)
    }

    function getParkList(mReqParkList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqParkList)
        api_getParkList({
            mReqParkList,
            success: (obj) => {
                // console.log(obj)
                setParkList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/Park_Add");
    }

    var baseTitle = "球場列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <ListBox row={6}lb={list_obj} srl={setParkList} count={count} page={page} sp={toSearch} searchItem={searchItem} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

